var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view__container" },
    [
      _vm._l(_vm.determinationDocuments, function(file) {
        return _c("DeterminationFileRow", {
          key: file.documentId,
          attrs: {
            "can-remove-document": _vm.canRemoveDocument,
            "can-replace": _vm.canReplace,
            "created-by": file.createdBy,
            "created-date": file.createdDate,
            "document-file-name": file.documentFileName,
            "document-id": file.determinationDocumentId,
            "document-name": file.documentName,
            "evaluator-name": file.evaluatorName,
            "is-provisional-remedy-area": _vm.isProvisionalRemedyArea
          },
          on: {
            download: function($event) {
              return _vm.downloadFile(file.documentId)
            },
            remove: function($event) {
              return _vm.onRemoveDocumentHandler(file)
            },
            replace: _vm.upsertFile
          }
        })
      }),
      _vm.isShowingUploadFile
        ? _c("DeterminationFileUpload", {
            attrs: {
              "is-provisional-remedy-area": _vm.isProvisionalRemedyArea
            },
            on: {
              cancel: function($event) {
                _vm.isShowingUploadFile = false
              },
              upload: _vm.upsertFile
            }
          })
        : _c("div", [
            _vm.determinationDocuments.length > 0
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c(
                      "action-button",
                      {
                        attrs: { i: "fas fa-file-plus", variant: "success" },
                        on: {
                          click: function($event) {
                            _vm.isShowingUploadFile = true
                          }
                        }
                      },
                      [_vm._v(" Añadir ")]
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "upload-file-button__container" },
                  [
                    _c(
                      "action-button",
                      {
                        staticClass: "upload-file-button",
                        attrs: {
                          "class-icon": "green-icon",
                          i: "fas fa-file-plus"
                        },
                        on: {
                          click: function($event) {
                            _vm.isShowingUploadFile = true
                          }
                        }
                      },
                      [_vm._v(" Presione aquí para anejar documento ")]
                    )
                  ],
                  1
                )
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }